import { Entity } from "./Entity.abstract";

export class ProspectEntity extends Entity {
    constructor(props) {
        super(props);
    }

    static restore(props) {
        return new ProspectEntity(props);
    }
}
